var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 16.5c0-1.248 2.18-3.472 3.173-4.42l1.345 5.765L4.134 20.2S3 19.066 3 16.5zm14.827-4.42C18.82 13.027 21 15.251 21 16.5c0 2.566-1.134 3.7-1.134 3.7l-3.392-2.355 1.353-5.766zM9.97 18.75h4.051L15.375 21h-6.75l1.345-2.25zM12.28 3.035c1.494.343 5.502 3.041 4.658 7.902l-1.564 6.688h-6.75l-1.564-6.688c-.853-4.86 3.216-7.568 4.675-7.902.088-.017.185-.035.264-.035.08 0 .176.018.281.035zM12 13.97a1.41 1.41 0 0 0 1.406-1.406A1.41 1.41 0 0 0 12 11.155a1.41 1.41 0 0 0-1.406 1.406A1.41 1.41 0 0 0 12 13.97zm0-5.625a1.41 1.41 0 0 0 1.406-1.406A1.41 1.41 0 0 0 12 5.53a1.41 1.41 0 0 0-1.406 1.407A1.41 1.41 0 0 0 12 8.344z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.85063b17af96e484195d82bdd529cda5.svg";
export { ForwardRef as ReactComponent };